<div class="validate-dialog" [class.is-valid]="isValido">
  <div class="validate-head">
    <div class="validate-icon" [class.ok]="isValido" [class.warn]="!isValido">
      <mat-icon>{{ isValido ? 'check_circle' : 'error_outline' }}</mat-icon>
    </div>
    <div class="validate-head-text">
      <h1 mat-dialog-title>Validação {{ data.documento }}</h1>
      <p class="validate-subtitle">
        {{ isValido
          ? (data.documento + ' está válido(a) e pronto(a) para prosseguir.')
          : 'Corrija os itens abaixo para continuar.' }}
      </p>
    </div>
  </div>

  <div mat-dialog-content class="validate-body">
    <div class="valid-empty" *ngIf="isValido">
      <mat-icon>verified</mat-icon>
      <span>Nenhuma pendência encontrada.</span>
    </div>

    <ul class="issue-list" *ngIf="!isValido">
      <li class="issue-item" *ngFor="let line of data.msg">
        <mat-icon>chevron_right</mat-icon>
        <span>{{ line }}</span>
      </li>
    </ul>
  </div>

  <div mat-dialog-actions align="end" class="validate-foot">
    <button mat-raised-button [mat-dialog-close]="true" color="primary">
      {{ data.confirmLabel ? data.confirmLabel : "Confirmar" }}
    </button>
  </div>
</div>
